// Per-floor SVG layout definitions for FloorMap
// Each floor key maps to an object with `elements` array.
// Element format: { type: 'rect'|'circle'|'path'|'polygon'|'text'|'group'|'line'|'raw', props: {...}, ... }

const floorLayouts = {
  1: {
    elements: [
      // --- Outside Stairs (Aligned with other floors) ---
      { type: 'circle', props: { cx: 310, cy: 115, r: 15, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'path', d: 'M 310 100 L 310 130 M 295 115 L 325 115', props: { stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Outside Stairs', props: { x: 340, y: 120, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10 } },

      // --- Espace Jeux (Top Left) ---
      { type: 'rect', props: { x: 230, y: 130, width: 70, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Jeux', props: { x: 265, y: 165, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- LT (Bottom Left) ---
      { type: 'rect', props: { x: 230, y: 190, width: 230, height: 100, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Cafeteria', props: { x: 265, y: 240, fill: '#00ff41', fontFamily: 'monospace', fontSize: 14, textAnchor: 'middle' } },

      // --- Espace Convivialité (Right) ---
      { type: 'rect', props: { x: 300, y: 130, width: 160, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Convivialité', props: { x: 380, y: 165, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Corridor ---
      { type: 'rect', props: { x: 310, y: 200, width: 150, height: 20, fill: '#1f2937', stroke: 'none', opacity: 0.5 } },

      // --- Bottom Row Rooms ---
      // Rés.
      { type: 'rect', props: { x: 470, y: 170, width: 40, height: 50, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs', props: { x: 490, y: 190, fill: '#00ff41', fontFamily: 'monospace', fontSize: 9, textAnchor: 'middle' } },

      // Bur.
      { type: 'rect', props: { x: 550, y: 170, width: 40, height: 50, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs', props: { x: 570, y: 190, fill: '#00ff41', fontFamily: 'monospace', fontSize: 9, textAnchor: 'middle' } },

      // --- Spiral Stairs (Internal) ---
      { type: 'circle', props: { cx: 480, cy: 210, r: 12, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },

      // --- Connection to Outside Stairs ---
      { type: 'path', d: 'M 310 115 L 310 130', props: { stroke: '#00ff41', strokeWidth: 1, strokeDasharray: '5,5' } }
    ]
  },
  2: {
    elements: [

      // --- Left Section (Stairs/Services) ---
      { type: 'rect', props: { x: 20, y: 180, width: 50, height: 100, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs/WC', props: { x: 45, y: 230, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle', transform: 'rotate(-90, 45, 230)' } },
      { type: 'rect', props: { x: 30, y: 190, width: 30, height: 30, fill: 'none', stroke: '#00ff41', strokeWidth: 1 } },

      // --- Coworking (Large Top) ---
      { type: 'rect', props: { x: 170, y: 40, width: 120, height: 150, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Coworking', props: { x: 230, y: 115, fill: '#00ff41', fontFamily: 'monospace', fontSize: 14, textAnchor: 'middle' } },

      // --- Outside Stairs (Right of Coworking) ---
      { type: 'circle', props: { cx: 310, cy: 115, r: 15, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'path', d: 'M 310 100 L 310 130 M 295 115 L 325 115', props: { stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Outside Stairs', props: { x: 340, y: 120, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10 } },

      // --- Bottom Rooms ---
      // Salle de cours (Left)
      { type: 'rect', props: { x: 70, y: 220, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 120, y: 250, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Salle de cours (Right)
      { type: 'rect', props: { x: 180, y: 220, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 230, y: 250, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Right Section Rooms ---
      // Salle de cours (Top)
      { type: 'rect', props: { x: 300, y: 140, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 350, y: 170, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Salle de cours (Bottom)
      { type: 'rect', props: { x: 300, y: 220, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 350, y: 250, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Offices (Top Right)
      { type: 'rect', props: { x: 400, y: 140, width: 30, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'rect', props: { x: 430, y: 140, width: 30, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },

      // Stairs/Rgt (Bottom Right)
      { type: 'rect', props: { x: 410, y: 220, width: 40, height: 40, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs', props: { x: 430, y: 245, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Angled Classroom (Far Right)
      { type: 'polygon', points: '460,220 520,220 500,280 460,280', props: { fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 485, y: 250, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Corridors ---
      { type: 'rect', props: { x: 60, y: 200, width: 400, height: 20, fill: '#1f2937', stroke: 'none', opacity: 0.5 } },
      { type: 'rect', props: { x: 280, y: 190, width: 20, height: 20, fill: '#1f2937', stroke: 'none', opacity: 0.5 } }
    ]
  },
  3: {
    elements: [
      // --- Left Section ---
      // Stairs/Services (Far Left)
      { type: 'rect', props: { x: 20, y: 180, width: 40, height: 100, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'WC/Stairs', props: { x: 40, y: 230, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle', transform: 'rotate(-90, 40, 230)' } },

      // 3 Small Offices (Top Left)
      { type: 'rect', props: { x: 70, y: 160, width: 30, height: 40, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'rect', props: { x: 100, y: 160, width: 30, height: 40, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'rect', props: { x: 130, y: 160, width: 30, height: 40, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Desk', props: { x: 115, y: 185, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // 2 Classrooms (Bottom Left)
      { type: 'rect', props: { x: 70, y: 220, width: 60, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'rect', props: { x: 130, y: 220, width: 60, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Work space', props: { x: 130, y: 255, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Center Section ---
      // Salle de Coworking (Large Top)
      { type: 'rect', props: { x: 170, y: 40, width: 120, height: 150, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Coworking', props: { x: 230, y: 115, fill: '#00ff41', fontFamily: 'monospace', fontSize: 14, textAnchor: 'middle' } },

      // --- Outside Stairs (Right of Coworking) ---
      { type: 'circle', props: { cx: 310, cy: 115, r: 15, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'path', d: 'M 310 100 L 310 130 M 295 115 L 325 115', props: { stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Outside Stairs', props: { x: 340, y: 120, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10 } },

      // Salle Convivialité (Middle/Bottom)
      { type: 'polygon', points: '170,200 220,200 220,280 170,280', props: { fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: '', props: { x: 195, y: 240, fill: '#00ff41', fontFamily: 'monospace', fontSize: 9, textAnchor: 'middle' } },

      // --- Right Section ---
      // Classroom Top
      { type: 'rect', props: { x: 300, y: 140, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Work space', props: { x: 350, y: 175, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Offices Top Right
      { type: 'rect', props: { x: 400, y: 140, width: 30, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'rect', props: { x: 430, y: 140, width: 30, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1 } },

      // Classroom Bottom
      { type: 'rect', props: { x: 300, y: 220, width: 100, height: 60, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Work space', props: { x: 350, y: 255, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Stairs/Rgt (Bottom Right)
      { type: 'rect', props: { x: 410, y: 220, width: 40, height: 40, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs', props: { x: 430, y: 245, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // Angled Classroom (Far Right)
      { type: 'polygon', points: '460,220 520,220 500,280 460,280', props: { fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Work space', props: { x: 485, y: 250, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Corridors ---
      // Main horizontal corridor
      { type: 'rect', props: { x: 60, y: 200, width: 400, height: 20, fill: '#1f2937', stroke: 'none', opacity: 0.5 } },
      // Vertical connection to Coworking
      { type: 'rect', props: { x: 280, y: 190, width: 20, height: 20, fill: '#1f2937', stroke: 'none', opacity: 0.5 } }
    ]
  },
  4: {
    elements: [
      // --- Left Section (Stairs/Services) ---
      { type: 'rect', props: { x: 20, y: 180, width: 50, height: 100, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs/WC', props: { x: 45, y: 230, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle', transform: 'rotate(-90, 45, 230)' } },
      { type: 'rect', props: { x: 30, y: 190, width: 30, height: 30, fill: 'none', stroke: '#00ff41', strokeWidth: 1 } },

      // --- Bottom Room (Salle de cours) ---
      { type: 'rect', props: { x: 70, y: 240, width: 240, height: 100, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 190, y: 290, fill: '#00ff41', fontFamily: 'monospace', fontSize: 14, textAnchor: 'middle' } },

      // --- Middle Room (Salle de cours) ---
      { type: 'rect', props: { x: 150, y: 140, width: 140, height: 80, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 220, y: 180, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10, textAnchor: 'middle' } },

      // --- Top Room (Salle de cours) ---
      { type: 'rect', props: { x: 150, y: 20, width: 140, height: 120, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 220, y: 80, fill: '#00ff41', fontFamily: 'monospace', fontSize: 12, textAnchor: 'middle' } },

      // --- Outside Stairs (Exit) ---
      { type: 'circle', props: { cx: 310, cy: 115, r: 15, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'path', d: 'M 310 100 L 310 130 M 295 115 L 325 115', props: { stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Outside Stairs', props: { x: 340, y: 120, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10 } },

      // --- Corridors ---
      // Path from left stairs, between rooms, to outside stairs
      { type: 'path', d: 'M 70 230 L 150 230 L 150 115 L 310 115', props: { stroke: '#1f2937', strokeWidth: 20, fill: 'none', opacity: 0.5, strokeLinecap: 'round', strokeLinejoin: 'round' } },
      { type: 'path', d: 'M 70 230 L 150 230 L 150 115 L 310 115', props: { stroke: '#00ff41', strokeWidth: 1, fill: 'none', strokeDasharray: '5,5' } }
    ]
  },
  5: {
    elements: [
      // --- Left Section (Stairs/Services) ---
      { type: 'rect', props: { x: 20, y: 180, width: 50, height: 100, fill: '#1f2937', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Stairs/WC', props: { x: 45, y: 230, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle', transform: 'rotate(-90, 45, 230)' } },
      { type: 'rect', props: { x: 30, y: 190, width: 30, height: 30, fill: 'none', stroke: '#00ff41', strokeWidth: 1 } },

      // --- Open Space (Top Right) ---
      { type: 'rect', props: { x: 150, y: 40, width: 150, height: 150, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Open Space', props: { x: 225, y: 115, fill: '#00ff41', fontFamily: 'monospace', fontSize: 14, textAnchor: 'middle' } },

      // --- Outside Stairs (Right of Open Space) ---
      { type: 'circle', props: { cx: 310, cy: 115, r: 15, fill: 'none', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'path', d: 'M 310 100 L 310 130 M 295 115 L 325 115', props: { stroke: '#00ff41', strokeWidth: 1 } },
      { type: 'text', text: 'Outside Stairs', props: { x: 340, y: 120, fill: '#00ff41', fontFamily: 'monospace', fontSize: 10 } },

      // --- Classrooms (Bottom Right) ---
      { type: 'rect', props: { x: 150, y: 200, width: 70, height: 80, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 185, y: 240, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle' } },

      { type: 'rect', props: { x: 230, y: 200, width: 70, height: 80, fill: '#151922', stroke: '#00ff41', strokeWidth: 1.5 } },
      { type: 'text', text: 'Salle de cours', props: { x: 265, y: 240, fill: '#00ff41', fontFamily: 'monospace', fontSize: 8, textAnchor: 'middle' } },

      // --- Corridors ---
      // Path from left stairs to main area
      { type: 'path', d: 'M 70 230 L 140 230 L 140 180 L 150 180', props: { stroke: '#1f2937', strokeWidth: 20, fill: 'none', opacity: 0.5, strokeLinecap: 'round', strokeLinejoin: 'round' } },
      { type: 'path', d: 'M 70 230 L 140 230 L 140 180 L 150 180', props: { stroke: '#00ff41', strokeWidth: 1, fill: 'none', strokeDasharray: '5,5' } }
    ]
  }
};

export default floorLayouts;
